import { defineStore } from "pinia"

export const useUiStore = defineStore("ui", {
  actions: {
    async runDashboardRefresh<T>(task: () => Promise<T>): Promise<T> {
      const finish = this.startDashboardRefresh()
      try {
        return await task()
      } finally {
        finish()
      }
    },
    startDashboardRefresh(): () => void {
      this.dashboardRefreshDepth += 1
      let active = true

      return () => {
        if (!active) {
          return
        }

        active = false
        this.dashboardRefreshDepth = Math.max(0, this.dashboardRefreshDepth - 1)
      }
    }
  },
  getters: {
    isDashboardRefreshing: (state) => state.dashboardRefreshDepth > 0
  },
  state: () => ({
    dashboardRefreshDepth: 0
  })
})
